/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Hidden_FailedInputs */



/**
* | output |
* | --- |
* | "We could not load your hidden colleagues. Please try again in a moment." |
*
* @param {Team_Hidden_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_hidden_failed = /** @type {((inputs?: Team_Hidden_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Hidden_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je verborgen collega's niet laden. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger vos collègues masqués. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not load your hidden colleagues. Please try again in a moment.")
});